import React from 'react';
import { useT } from 'client/i18n/hooks/useT';
import { MarketingImage } from 'client/components/MarketingPagesShared/MarketingImage';
import { useBrowserSize } from 'client/contexts/BrowserSize';
import { BREAKPOINT_SMALL } from 'client/components/MarketingPagesShared/styles';
import { paths } from 'client/shared/Paths';
import { HomeSectionTitle } from '../../../styles';
import {
  HomeInspirationBackground,
  HomeInspirationImageColumn,
  HomeInspirationSection,
  HomeSectionSubtitle,
  StyledMarketingButton,
} from './styles';

export function HomeInspiration({ onClickCTA }: { onClickCTA?: () => void }) {
  const t = useT();
  const { width } = useBrowserSize();
  const isMobileWidth = width <= BREAKPOINT_SMALL;
  return (
    <HomeInspirationBackground>
      <HomeInspirationSection>
        <div>
          <HomeSectionTitle>
            <strong>
              {t(
                'HomePage.HomeInspiration.Title',
                'Podcasting tips, creator stories, and Anchor news',
                'Anchor home page inspiration section title'
              )}
            </strong>
          </HomeSectionTitle>
          <HomeSectionSubtitle>
            {t(
              'HomePage.HomeInspiration.Subtitle',
              'Our blog, Word of Mouth, has everything you need to get started or take your show to the next level.',
              'Anchor home page inspiration section subtitle'
            )}
          </HomeSectionSubtitle>
          <StyledMarketingButton
            kind="link"
            href={paths.blog.home}
            target="_blank"
            onClick={onClickCTA}
          >
            {t(
              'HomePage.HomeInspiration.SeeLatestNewsButtonLabel',
              'See the latest',
              'Anchor blog page link text'
            )}
          </StyledMarketingButton>
        </div>
        <HomeInspirationImageColumn>
          {isMobileWidth ? (
            <MarketingImage
              width={335}
              height={340}
              isDropShadowed={false}
              imagePath="home/inspiration/covers-mobile"
              alt={t(
                'HomePage.HomeInspiration.InspirationImageAlt',
                'A picture with multiple podcast covers',
                'Anchor home page inspiration image screenreader information'
              )}
            />
          ) : (
            <MarketingImage
              width={640}
              height={523}
              isDropShadowed={false}
              imagePath="home/inspiration/covers-desktop"
              alt={t(
                'HomePage.HomeInspiration.InspirationImageAlt',
                'A picture with multiple podcast covers',
                'Anchor home page inspiration image screenreader information'
              )}
            />
          )}
        </HomeInspirationImageColumn>
      </HomeInspirationSection>
    </HomeInspirationBackground>
  );
}
